import axiosHelper from './helpers/axiosHelper';
import LegalEntityModel from './models/LegalEntityModel';

const entitiesModule = {
	state() {
		return {	
			/** @type {Array<LegalEntityModel>} */
			executives: null
		}
	},
	actions: {
		/** load list of executive entities are managed for providing service/repairment for customers */
		async fetchExecutivesAsync(ctx: any) {			
			try {
				const jwt = ctx.getters.jwt;
				const a = axiosHelper.createInstance(jwt);
				const response = await a.get('/api/legalEntities/executives');
				const executeEntities = response.data.map((_: any) => new LegalEntityModel(_));
				ctx.commit('setEntities', executeEntities);
			} catch (e) {
				console.error('Error loading executive entities list', e);
			}
		}
	},
	mutations: {		
		setEntities(state: any, payload: Array<LegalEntityModel>) {
			state.executives = payload;
		},
	},
	getters: {
		/** list of executive entities are managed for providing service/repairment for customers */
		executives(state: any) : Array<LegalEntityModel> {
			return state.executives;
		},
	}
};

export default entitiesModule;